













import {Component, Vue} from "vue-property-decorator";
import BookButton from "@/components/landing/BookButton.vue";
@Component({
  components: {BookButton},
})
export default class Jumbotron extends Vue {}
